<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',

    mounted() {},
  };
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Assistant:wght@100;200;300;400;500;600;700;800;900&display=swap');

  @font-face {
    font-family: 'Work Sans';
    src: url('~@/assets/fonts/Work_Sans/static/WorkSans-Regular.ttf')
      format('truetype');
    font-weight: 400;
  }

  @font-face {
    font-family: 'Work Sans';
    src: url('~@/assets/fonts/Work_Sans/static/WorkSans-Medium.ttf')
      format('truetype');
    font-weight: 500;
  }

  @font-face {
    font-family: 'Work Sans';
    src: url('~@/assets/fonts/Work_Sans/static/WorkSans-SemiBold.ttf')
      format('truetype');
    font-weight: 600;
  }

  @font-face {
    font-family: 'Work Sans';
    src: url('~@/assets/fonts/Work_Sans/static/WorkSans-Bold.ttf')
      format('truetype');
    font-weight: 700;
  }

  #app * {
    font-family: 'Assistant';
    font-variant-caps: normal;
    font-variant-east-asian: normal;
    font-variant-ligatures: normal;
    font-variant-numeric: tabular-nums;
    /* color-adjust: exact;
  filter: Glow(Color=#a0ffa0, Strength=5); */
  }

  .application--wrap {
    -webkit-backface-visibility: initial !important;
    backface-visibility: initial !important;
    /* re-enabling windows clearType disabled by vuetify */
  }

  .v-btn {
    text-transform: none !important;
  }

  .background {
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 80vh;
  }

  .divider {
    border: 0.5px solid #eeeeee;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .textFieldLabel {
    margin-top: 8px;
    margin-bottom: 8px;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;

    color: #000000;
  }

  .required {
    color: #d91212;
  }

  .pageTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 57px !important;
    line-height: 64px !important;
  }

  .pageSubtitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }

  .videoFrame {
    /* override other styles to make responsive */
    width: 100% !important;
  }

  .guideText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000000;
    white-space: pre-line;
  }

  .blackButton {
    height: 56px !important;
    background: #000 !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #fff !important;
  }

  .yellowButton {
    height: 56px !important;
    background: #fed85d !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #151515 !important;
  }

  .pinkButton {
    height: 56px !important;
    background: #ff8dd8 !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #151515 !important;
  }

  .button {
    height: 56px !important;
    background: #151515 !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 20px !important;
  }

  .tabButton {
    height: 56px !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 24px !important;
    line-height: 32px !important;
    color: #000 !important;
    background: transparent !important;
  }

  .selectedTabButton {
    pointer-events: none;
    background: #151515 !important;
    color: #fff !important;
  }

  .disabledTabButton {
    pointer-events: none;
    color: #a1a1a1 !important;
  }

  .clickable {
    cursor: pointer;
  }
</style>
